import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@awaze/design-system.components.text';
import { isPopularDestination } from '@awaze/design-system.utils.form';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import React from 'react';
import styled from 'styled-components';
import { useSearchFormContext } from '../../search-form.context';
import { StyledDestinationItem } from './destination-item';
const StyledText = styled.div `
  padding-left: ${({ indented }) => (indented ? 0 : pxToRems(16))};
`;
export const DestinationList = ({ locations, closeAccordion, onDestinationSelected, }) => {
    const { formHooks, legacyListWithPlaces } = useSearchFormContext();
    const selectRegion = (region) => {
        const { regionValue, url, regionId } = region;
        const [accommodationType] = formHooks.getValues(['accommodationType']);
        const placesId = (legacyListWithPlaces.enabled) ? region?.placesId : '';
        if (isPopularDestination(regionId)) {
            formHooks.setValue('featureId', regionId);
            formHooks.setValue('destinationId', '');
        }
        else {
            formHooks.setValue('destinationId', regionId);
            formHooks.setValue('featureId', '');
        }
        formHooks.setValue('destination', regionValue);
        formHooks.setValue('id', placesId);
        formHooks.setValue('destinationURL', accommodationType ? `/${accommodationType}${url}` : url);
        closeAccordion?.();
        onDestinationSelected?.();
    };
    return (_jsx(_Fragment, { children: locations.map((region) => {
            return (_jsxs(React.Fragment, { children: [_jsx(StyledDestinationItem, { onClick: () => selectRegion(region), tabIndex: 0, role: "button", type: "button", children: _jsx(StyledText, { indented: Boolean(region.regions), children: _jsx(Text, { sizes: region.regions &&
                                    window?.matchMedia(`(min-width: ${breakpoints[0]}px)`)
                                        ?.matches
                                    ? 400
                                    : 300, type: region.regions ? 'mid' : 'regular', children: region.regionName }) }) }, `listItem-${region.regionId}`), region.regions && (_jsx(DestinationList, { locations: region.regions, closeAccordion: closeAccordion, onDestinationSelected: onDestinationSelected }))] }, `listItem-${region.regionId}`));
        }) }));
};
//# sourceMappingURL=destination-list.js.map